import React from "react";
import PdfViewer from "../../PdfViewer";

const EntregaServicioCliente = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/06-implementacion-y-entrega-de-servicios-a-cliente.pdf`;
  /*const pdfUrl = "/pdf/06-implementacion-y-entrega-de-servicios-a-cliente.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Entrega de Servicio a Cliente</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default EntregaServicioCliente;
